import LeadForm from "@/components/site/LeadForm";
import PageHero from "@/components/site/PageHero";
import { useSEO } from "@/lib/seo";
import { linkifyGoAndTrack } from "@/lib/goAndTrack";
import { CheckCircle2 } from "lucide-react";

export default function RequestTrial() {
  useSEO({
    title: "Speak to an Expert — Disposable Smart Labels",
    description:
      "Speak to a specialist about disposable smart labels for shipment visibility. Tell us about your lanes and we'll come back with a scoped pilot proposal.",
    canonical: "/request-a-trial",
  });

  return (
    <div data-testid="page-request-trial">
      <PageHero
        eyebrow="Get started"
        title="Speak to an expert"
        subtitle="Tell us about your lanes, shipment profile, and what you're trying to test. A specialist will respond with a structured pilot proposal."
      />
      <section className="section">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-4">What you&apos;ll get</p>
            <ul className="space-y-4 mt-6">
              {[
                "A reply from a specialist within one business day.",
                "A scoped pilot covering lane, shipment count, KPIs, and review timeline.",
                "Hands-on integration support for GoAndTrack into your existing systems.",
                "Clear commercials with no upfront hardware commitment.",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-[15px] text-ink">
                  <CheckCircle2 className="h-4 w-4 mt-1 text-brand shrink-0" />
                  {linkifyGoAndTrack(b)}
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7">
            <LeadForm
              source="speak-to-an-expert"
              heading="Send us your enquiry"
              subheading="The more detail you share, the more useful our first reply will be."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
